export const variantPrefix = 'portodoacu'

export const origins = {
  judgeOriginIdentifier: `${variantPrefix}judge`,
  judgeStep2OriginIdentifier: `${variantPrefix}judgestep2`,
  partnerOriginIdentifier: `${variantPrefix}partner`,
  mentorOriginIdentifier: `${variantPrefix}mentor`,
  individualOriginIdentifier: `${variantPrefix}individual`,
  startupsOriginIdentifier: `${variantPrefix}startups`,
  reportTeamOriginIdentifier: `${variantPrefix}reportteam`,
  reportAOriginIdentifier: `${variantPrefix}reporta`,
  reportBOriginIdentifier: `${variantPrefix}reportb`,
  reportCOriginIdentifier: `${variantPrefix}reportc`,
}

export const originsIdentifiers = Object.values(origins)
